import { render, staticRenderFns } from "./CampaignSidebar.vue?vue&type=template&id=b4f1532e&scoped=true&"
import script from "./CampaignSidebar.vue?vue&type=script&lang=ts&"
export * from "./CampaignSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignSidebar.vue?vue&type=style&index=0&id=b4f1532e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f1532e",
  null
  
)

export default component.exports